import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tv" }
const _hoisted_2 = {
  key: 1,
  class: "content-list"
}
const _hoisted_3 = {
  key: 0,
  class: "loading"
}

import { watch, computed } from 'vue'
import CinemaCard from '@remote/components/cinema/CinemaCard.vue'
import CinemaEmpty from '@remote/components/cinema/CinemaEmpty.vue'
import { stat } from '@remote/utils/stat'
import { useCinemaStore } from '@remote/store/cinema'
import { useCinemaLayout } from '@remote/composable/cinema'


export default /*#__PURE__*/_defineComponent({
  props: {
  isShowing: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const { layout } = useCinemaLayout()



const cinemaStore = useCinemaStore()
const isEmpty = computed(() => cinemaStore.tvList.length === 0)

watch(() => props.isShowing, () => {
  if (props.isShowing) {
    stat({
      action: 'cinema_channel_show',
      data: {
        if_content_blank: cinemaStore.tvList.length === 0 ? 1 : 0,
        page: 'tv',
        status: cinemaStore.isScraping ? 1 : 0,
      },
    })
  }
})


return (_ctx: any,_cache: any) => {
  const _directive_observer = _resolveDirective("observer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isEmpty))
      ? (_openBlock(), _createBlock(CinemaEmpty, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cinemaStore).tvList, (item) => {
            return (_openBlock(), _createBlock(CinemaCard, {
              key: item.video_info?.file_id,
              nfo: item,
              style: _normalizeStyle({ width: _unref(layout).width, maxWidth: _unref(layout).maxWidth }),
              "click-from": "tele"
            }, null, 8, ["nfo", "style"]))
          }), 128)),
          (!_unref(cinemaStore).isTvListEnd && !_unref(cinemaStore).isScraping)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, null, 512)), [
                [_directive_observer, { show: _unref(cinemaStore).loadTvNFOList }]
              ])
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})